import { render, staticRenderFns } from "./RFMSection.vue?vue&type=template&id=8665d302&scoped=true&"
import script from "./RFMSection.vue?vue&type=script&lang=js&"
export * from "./RFMSection.vue?vue&type=script&lang=js&"
import style0 from "./RFMSection.vue?vue&type=style&index=0&id=8665d302&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8665d302",
  null
  
)

export default component.exports